import React from 'react';
import { useRouter } from 'next/router';

import PopUpContactUs from 'components/ContactUs/PopUpContactUs';
import { Metadata } from 'components/Metadata';
import { ORIGIN } from 'src/constants';
import Header from 'components/layouts/Header/Header';
import ContentGroupTracker from 'src/gtm/ContentGroupTracker';

// Shared branded 404 body. Rendered both by pages/404.tsx and by the
// client-side stale-slug guard, so an orphaned URL shows the exact same 404.
const NotFoundPage: React.FC = () => {
  const { asPath } = useRouter();

  return (
    <>
      <Metadata
        {...{
          title: `Not Found | CondoBlackBook`,
          url: `${ORIGIN}${asPath}`,
        }}
      />
      <ContentGroupTracker pageGroup={'other'} />
      <Header />
      <section className="container flex flex-col">
        <div className="flex justify-center text-git sxl py-14">
          Sorry, we can&apos;t seem to find the page you are looking for.
        </div>
        <div className="flex justify-center text-git sxl py-14">
          Didn’t find what you want?&nbsp;
          <PopUpContactUs contactUsNotButton={'Contact us'} />
          &nbsp;for exclusive off-market listings
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
